export default {
  REDIRECT: 'REDIRECT',
  IDENTIFY: 'IDENTIFY',
  CHALLENGE: 'CHALLENGE',
};
